"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustSelection = exports.locToInsertionPos = exports.locToPos = exports.charactersBeforeNode = exports.nodeForKey = exports.posToLoc = exports.idAfter = exports.formatAt = exports.adjustForFormat = exports.posToPostLoc = exports.posToPreLoc = exports.nextSibling = exports.nextNode = exports.prevSibling = exports.lastChild = exports.fmtIdx = exports.walk = exports.walkFrom = exports.lastId = exports.rootParent = exports.rootSite = void 0;
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const utils_1 = require("./utils");
exports.rootSite = '-root-';
exports.rootParent = '0:-root-';
exports.lastId = (node) => {
    if (node.content.type === 'text') {
        return [node.id[0] + node.content.text.length - 1, node.id[1]];
    }
    return node.id;
};
// Ok I actually need a better plan
// char-space -> crdt-space
// and back.
// 'abc'
// we need to select an "anchoring"
// certainly the 'start' of a selection anchors right
// and the 'end' anchors left.
// dunno what a good default is for the cursor when
// not selecting, but that can be decided.
/*

| a | b | c | d | e |
0   1   2   3   4   5

yeah just 1 or 0 for the side, true or false.

0(left) is [0:root,1]
0(right) is [1:a, 0]
1(left) is [1:a, 1]
1(right) is [2:a, 0]

*/
const walkLoop = (state, id, fn, all = false) => {
    const node = state.map[id];
    if (!node)
        return console.error(`Missing node! ${id}`);
    if (!node.deleted || all) {
        if (fn(node) === false) {
            return false;
        }
    }
    if (state.map[id].children.some(child => walkLoop(state, child, fn, all) === false)) {
        return false;
    }
};
exports.walkFrom = (state, key, fn, all = false) => {
    if (walkLoop(state, key, fn, all) === false) {
        return;
    }
    const walkUp = key => {
        if (key === exports.rootParent) {
            return;
        }
        const node = state.map[key];
        const siblings = node.parent === exports.rootParent
            ? state.roots
            : state.map[node.parent].children;
        const idx = siblings.indexOf(key);
        if (idx === -1) {
            throw new Error(`${key} not found in children of ${node.parent} : ${siblings.join(', ')}`);
        }
        for (let i = idx + 1; i < siblings.length; i++) {
            if (walkLoop(state, siblings[i], fn, all) === false) {
                return;
            }
        }
        return walkUp(node.parent);
    };
    walkUp(key);
};
exports.walk = (state, fn, all = false) => {
    state.roots.some(id => walkLoop(state, id, fn, all) === false);
};
exports.fmtIdx = (fmt, content) => {
    for (let i = 0; i < fmt.length; i++) {
        if (fmt[i].stamp < content.stamp) {
            return i;
        }
    }
    return fmt.length;
};
exports.lastChild = (crdt, id) => {
    const node = crdt.map[id];
    if (node.children.length) {
        return exports.lastChild(crdt, node.children[node.children.length - 1]);
    }
    else {
        return id;
    }
};
exports.prevSibling = (crdt, node) => {
    if (node.parent === exports.rootParent) {
        const idx = crdt.roots.indexOf(utils_1.toKey(node.id));
        if (idx === -1 || idx === 0) {
            return; // selection went too far
        }
        return exports.lastChild(crdt, crdt.roots[idx - 1]);
    }
    else {
        const parent = crdt.map[node.parent];
        const idx = parent.children.indexOf(utils_1.toKey(node.id));
        if (idx === -1) {
            throw new Error(`Can't find node in parents`);
        }
        if (idx === 0) {
            return exports.prevSibling(crdt, parent);
        }
        return parent.children[idx + 1];
    }
};
exports.nextNode = (crdt, node) => {
    if (node.children.length) {
        return node.children[0];
    }
    return exports.nextSibling(crdt, node);
};
// Get the next sibling or parent's next sibling
exports.nextSibling = function (crdt, node) {
    // console.log('sib', node);
    if (node.parent === exports.rootParent) {
        const idx = crdt.roots.indexOf(utils_1.toKey(node.id));
        if (idx === -1 || idx + 1 >= crdt.roots.length) {
            // console.log('root out');
            return; // selection went too far
        }
        return crdt.roots[idx + 1];
    }
    else {
        const parent = crdt.map[node.parent];
        const key = utils_1.toKey(node.id);
        const idx = parent.children.indexOf(key);
        if (idx === -1) {
            throw new Error(`Can't find node ${key} in parents ${parent.children.join(';')}`);
        }
        if (idx + 1 >= parent.children.length) {
            return exports.nextSibling(crdt, parent);
        }
        return parent.children[idx + 1];
    }
};
const posToPreLocForNode = (state, node, pos) => {
    // Only text nodes should be pre-locs
    if (pos === 1 && !node.deleted && node.content.type === 'text') {
        return [node.id, 0];
    }
    if (pos > node.size) {
        throw new Error(`pos ${pos} not in node ${utils_1.toKey(node.id)}`);
    }
    if (!node.deleted && node.content.type === 'text') {
        if (pos <= node.content.text.length) {
            return [node.id, pos - 1];
        }
        pos -= node.content.text.length;
    }
    for (let i = 0; i < node.children.length; i++) {
        const child = state.map[node.children[i]];
        if (pos <= child.size) {
            return posToPreLocForNode(state, child, pos);
        }
        pos -= child.size;
    }
    throw new Error(`Node size caches must have been miscalculated! Pos ${pos} not found in node ${utils_1.toKey(node.id)}, even though node's size is ${node.size}`);
};
// This represents the loc that is before the pos...
exports.posToPreLoc = (crdt, pos) => {
    if (pos === 0) {
        return [[0, exports.rootSite], 0];
    }
    for (let i = 0; i < crdt.roots.length; i++) {
        const root = crdt.map[crdt.roots[i]];
        if (pos <= root.size) {
            return posToPreLocForNode(crdt, root, pos);
        }
        pos -= root.size;
    }
    throw new Error(`Pos ${pos} is outside the bounds`);
};
const posToPostLocForNode = (state, node, pos) => {
    if (pos === 0 && !node.deleted) {
        return [node.id, 0];
    }
    if (pos >= node.size) {
        throw new Error(`post pos ${pos} not in node ${utils_1.toKey(node.id)}`);
    }
    if (!node.deleted && node.content.type === 'text') {
        if (pos < node.content.text.length) {
            return [node.id, pos];
            // return [node.id[0] + pos, node.id[1]];
        }
        pos -= node.content.text.length;
    }
    for (let i = 0; i < node.children.length; i++) {
        const child = state.map[node.children[i]];
        if (pos < child.size) {
            return posToPostLocForNode(state, child, pos);
        }
        pos -= child.size;
    }
    throw new Error(`Node size caches must have been miscalculated! Post pos ${pos} not found in node ${utils_1.toKey(node.id)}, even though node's size is ${node.size}`);
};
// this represents the loc that is after the pos
exports.posToPostLoc = (crdt, pos) => {
    for (let i = 0; i < crdt.roots.length; i++) {
        const root = crdt.map[crdt.roots[i]];
        if (pos < root.size) {
            return posToPostLocForNode(crdt, root, pos);
        }
        pos -= root.size;
    }
    if (pos === 0) {
        return [[1, exports.rootSite], 0];
    }
    throw new Error(`Pos ${pos} is outside the bounds`);
};
const countDifferences = (one, two) => {
    let differences = 0;
    Object.keys(one).forEach(key => {
        if (!fast_deep_equal_1.default(one[key], two[key])) {
            differences += 1;
        }
    });
    Object.keys(two).forEach(key => {
        if (!(key in one)) {
            differences += 1;
        }
    });
    return differences;
};
exports.adjustForFormat = (state, loc, format) => {
    // if we're right next to some opens or closes, see
    // if any of the adjacent spots already have the desired
    // formatting.
    const node = exports.nodeForKey(state, [loc.id, loc.site]);
    if (!node) {
        return loc;
    }
    if (node.content.type === 'text' &&
        loc.id < node.id[0] + node.content.text.length - 1) {
        // we're in the middle of a text node
        return loc;
    }
    // console.log('adjusting, at the end I guess', loc, node.id);
    const nodeFormat = utils_1.getFormatValues(state, node.formats);
    if (fast_deep_equal_1.default(format, nodeFormat)) {
        return loc;
    }
    if (loc.pre) {
        const options = [
            [countDifferences(format, nodeFormat), 0, loc, nodeFormat],
        ];
        const orig = node;
        exports.walkFrom(state, utils_1.toKey(node.id), node => {
            if (node.id === orig.id) {
                return;
            }
            if (node.content.type === 'text') {
                return false;
            }
            const fmt = utils_1.getFormatValues(state, node.formats);
            options.push([
                countDifferences(format, fmt),
                options.length,
                { id: node.id[0], site: node.id[1], pre: true },
                fmt,
            ]);
        });
        options.sort((a, b) => (a[0] === b[0] ? a[1] - b[1] : a[0] - b[0]));
        // maybe I want a generator, so I can step through
        // the formatting nodes that face me?
        return options[0][2];
    }
    else {
        return loc; // TODO fix this
    }
    // do the nodes have formattings
};
exports.formatAt = function (crdt, pos) {
    try {
        const node = exports.nodeForKey(crdt, pos);
        // console.log('format at', pos, node.formats)
        // const [id, offset] = posToPostLoc(crdt, pos);
        // const node = nodeForKey(crdt, id);
        const format = {};
        if (!node) {
            return format;
        }
        Object.keys(node.formats).forEach(key => {
            // hmm whats the point of doing it by ID? yeah there is one, its ok
            if (node.formats[key].length) {
                const fmtNode = crdt.map[node.formats[key][0]];
                if (fmtNode.content.type !== 'open') {
                    throw new Error(`non-open node (${node.formats[key][0]}) found in a formats cache for ${utils_1.toKey(node.id)}`);
                }
                format[key] = fmtNode.content.value;
            }
        });
        return format;
    }
    catch {
        return {};
    }
};
exports.idAfter = function (crdt, loc) {
    if (!loc.pre) {
        return loc.id;
    }
    if (utils_1.keyEq([loc.id, loc.site], [0, exports.rootSite])) {
        const key = crdt.roots[0];
        if (key) {
            return crdt.map[key].id[0];
        }
        return 0;
    }
    const node = exports.nodeForKey(crdt, [loc.id, loc.site]);
    if (node && node.id[0] + utils_1.contentLength(node.content) - 1 == loc.id) {
        if (node.children.length) {
            return crdt.map[node.children[0]].id[0];
        }
        const next = exports.nextSibling(crdt, node);
        if (next != null) {
            return crdt.map[next].id[0];
        }
    }
    return 0;
};
exports.posToLoc = function (crdt, pos, 
// if true, loc is the char to the left of the pos (the "pre-loc")
// if false, loc is the char to the right of the pos (the "post-loc")
anchorToLocAtLeft) {
    const total = utils_1.length(crdt);
    if (pos > total) {
        debugger;
        throw new Error(`Loc ${pos} is outside of the bounds ${total}`);
    }
    const [[id, site], offset] = anchorToLocAtLeft
        ? exports.posToPreLoc(crdt, pos)
        : exports.posToPostLoc(crdt, pos);
    return { id: id + offset, site, pre: anchorToLocAtLeft };
};
exports.nodeForKey = function (crdt, key) {
    for (let i = key[0]; i >= 0; i--) {
        const k = utils_1.toKey([i, key[1]]);
        if (crdt.map[k]) {
            return crdt.map[k];
        }
    }
};
exports.charactersBeforeNode = function (crdt, node) {
    let total = 0;
    while (node) {
        const siblings = node.parent === exports.rootParent
            ? crdt.roots
            : crdt.map[node.parent].children;
        const idx = siblings.indexOf(utils_1.toKey(node.id));
        if (idx === -1) {
            throw new Error(`node not found in parents children ${utils_1.toKey(node.id)} ${node.parent} - ${siblings.join(';')}`);
        }
        for (let i = 0; i < idx; i++) {
            total += crdt.map[siblings[i]].size;
        }
        if (node.parent === exports.rootParent) {
            break;
        }
        else {
            node = crdt.map[node.parent];
            if (!node.deleted && node.content.type === 'text') {
                total += node.content.text.length;
            }
        }
    }
    return total;
};
exports.locToPos = function (crdt, loc) {
    if (loc.site === exports.rootSite) {
        return loc.id === 0 ? 0 : utils_1.length(crdt);
    }
    // step 1: find the node this loc is within
    const node = exports.nodeForKey(crdt, [loc.id, loc.site]);
    if (!node) {
        throw new Error(`Loc does not exist in tree ${JSON.stringify(loc)}`);
    }
    // step 2: find the position-in-text for this node
    const nodePos = exports.charactersBeforeNode(crdt, node);
    if (node.deleted) {
        return nodePos;
    }
    // step 3: adjust for an internal ID
    const offset = loc.id - node.id[0];
    // step 4: if it's pre (and we're a text node) add 1
    return nodePos + offset + (loc.pre && node.content.type === 'text' ? 1 : 0);
};
exports.locToInsertionPos = function (crdt, after, id) {
    if (after[1] === exports.rootSite) {
        let idx = crdt.roots.length;
        let pos = 0;
        for (let i = 0; i < crdt.roots.length; i++) {
            if (utils_1.keyCmp(utils_1.fromKey(crdt.roots[i]), id) < 1) {
                idx = i;
                break;
            }
            pos += crdt.map[crdt.roots[i]].size;
        }
        return pos;
    }
    // step 1: find the parent node
    const node = exports.nodeForKey(crdt, after);
    if (!node) {
        throw new Error(`Loc does not exist in tree ${JSON.stringify(after)}`);
    }
    // step 2: find the position-in-text for this node
    let nodePos = exports.charactersBeforeNode(crdt, node);
    // We're at the end, in competition with other children
    if (node.id[0] + utils_1.contentLength(node.content) === after[0] + 1) {
        nodePos += utils_1.contentChars(node.content);
        let idx = node.children.length;
        for (let i = 0; i < node.children.length; i++) {
            if (utils_1.keyCmp(utils_1.fromKey(node.children[i]), id) < 1) {
                idx = i;
                break;
            }
            nodePos += crdt.map[node.children[i]].size;
        }
        // console.log('at the end', node.content, node.id, after);
        return nodePos; // - 1;
    }
    else {
        // console.log('ok', after, node.id, node.content.type, nodePos);
        // no one here but us
        const offset = after[0] - node.id[0];
        return nodePos + offset + 1; // TODO??? (node.content.type === 'text' ? 1 : 0);
    }
};
exports.adjustSelection = (prev, current, start, end) => {
    const startLoc = exports.posToLoc(prev, start, false);
    const endLoc = exports.posToLoc(prev, end, true);
    // console.log('locs', startLoc, endLoc);
    const newStart = exports.locToPos(current, startLoc);
    const newEnd = exports.locToPos(current, endLoc);
    return { start: newStart, end: newEnd };
};
